import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto, theme, transientOptions } from "shared/lib/styles";

export const Container = styled.nav`
  display: none;

  background-color: #ffffff;

  ${theme.breakpoints.up("tablet")} {
    display: block;

    block-size: 45px;
    padding-block: 10.5px;
  }

  ${theme.breakpoints.up("desktop")} {
    block-size: 46px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  block-size: 100%;
  max-inline-size: 1208px;
  margin-inline: auto;
`;

export const LeftWrapper = styled.div`
  display: flex;
  flex: 1 1 auto;
  gap: 16px;
  align-items: center;
`;

export const CenterWrapper = styled.div`
  position: absolute;
  inset-inline-start: 50%;

  display: flex;
  justify-content: center;

  transform: translateX(-50%);
`;

export const RightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;

  ${theme.breakpoints.up("tablet")} {
    gap: 8px;
  }

  ${theme.breakpoints.up("desktop")} {
    gap: 16px;
  }
`;

type EditionProps = {
  $isActive: boolean;
};
export const Edition = styled("div", { ...transientOptions })<EditionProps>`
  display: block;

  color: #333333;
  font-size: 11px;
  line-height: 13px;
  white-space: nowrap;
  text-transform: uppercase;

  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  ${props =>
    props.$isActive
      ? css`
          color: #000000;
          font-weight: 700;
          &:hover {
            text-decoration: none;
          }
        `
      : null}

  ${theme.breakpoints.up("desktop")} {
    font-size: 12px;
    line-height: 14px;
  }
`;

export const EditionList = styled.div`
  display: flex;
  column-gap: 16px;
  justify-content: flex-start;
  align-items: center;

  inline-size: 219px;
  padding-inline-end: 16px;

  border-inline-end: 1px solid #333333;

  ${theme.breakpoints.up("tablet")} {
    column-gap: 10px;

    inline-size: auto;
    padding-inline-end: 10px;
  }

  ${theme.breakpoints.up("desktop")} {
    column-gap: 24px;

    inline-size: 260px;
    padding-inline-end: 24px;
  }
`;

export const DateWeatherAndBackToOldScmpButton = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

export const DateWeather = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

export const DisplayDate = styled.div`
  color: #ffffff;
  font-size: 12px;

  b {
    display: inline-block;

    margin-inline-end: 4px;
  }
`;

export const BackToOriginalScmpButton = styled.div`
  inline-size: fit-content;
  padding-block: 8px;
  padding-inline: 12px;

  color: #001246;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRoboto};
  font-style: normal;
  line-height: normal;

  background-color: #ffca05;

  cursor: pointer;
`;

export const SCMPPlusTabs = styled.div`
  display: flex;
  align-items: center;
`;

type SCMPPlusTabsListProps = {
  $isActive: boolean;
};
export const SCMPPlusTabsList = styled("div", {
  ...transientOptions,
})<SCMPPlusTabsListProps>`
  padding-block: 8px;
  padding-inline: 12px;

  color: #ffffff;
  font-weight: 900;
  font-size: 14px;
  text-transform: uppercase;

  border-radius: 4px 4px 0 0;

  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  ${props =>
    props.$isActive
      ? css`
          color: #001246;

          background-color: #ffca05;

          &:hover {
            text-decoration: none;
          }
        `
      : null}
`;
